import {useState, useEffect} from 'react';

export function useScreenSize() {
	const [screenSize, setScreenSize] = useState({
		width: window.innerWidth, height: window.innerHeight
	});

	useEffect(() => {
		const handleResize = () => {
			setScreenSize({
				width: window.innerWidth, height: window.innerHeight
			});
		};

		window.addEventListener('resize', handleResize);

		// Cleanup
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return screenSize;
}
